<script lang="ts">
    import CloseIcon from "../../../svelte/icons/closeIcon.svelte";
    import MagnifyIcon from "../../../svelte/icons/magnifyIcon.svelte";

    type Props = {
        value: string;
        onInput?: (e: Event) => unknown;
    };
    let { value = $bindable(), onInput }: Props = $props();
</script>

<div class="search">
    <div class="icon">
        <MagnifyIcon />
    </div>
    <input type="text" class="std-input" bind:value oninput={onInput} placeholder="Search Jobs" />
    <button
        class="clear"
        onclick={() => {
            value = "";
        }}
    >
        <CloseIcon clr={value === "" ? "#ccc" : "hsl(var(--clr-error-5))"} />
    </button>
</div>

<style lang="scss">
    .search {
        display: grid;
        grid-template-columns: max-content 1fr max-content;
        align-items: center;
        input {
            grid-area: 1 / 1 / 2 / 4;
            padding: 0.25rem 0.5rem 0.25rem 2rem;
            height: 1.75rem;
            border: 1px solid var(--border);
            border-radius: 0.375rem;
            background: var(--background);
            color: var(--foreground);
            font-size: 0.75rem;
            outline: none;
            transition: border-color 150ms, box-shadow 150ms;
        }
        input:focus-visible {
            border-color: var(--ring, var(--primary));
            box-shadow: 0 0 0 2px color-mix(in srgb, var(--ring, var(--primary)) 25%, transparent);
        }
    }
    .icon {
        padding: 0.25rem;
        grid-area: 1 / 1 / 2 / 2;
        z-index: 5;
        pointer-events: none;
    }
    .clear {
        padding: 0.25rem;
        grid-area: 1 / 3 / 2 / 4;
        z-index: 5;
    }
</style>
